<template>
  <div v-role="roles">
    <div>
      <div class="formPosition">
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <template>
          <v-form ref="form" v-model="formValid" lazy-validation>
            <v-container class="text-md-left">
              <v-row no-gutters>
                <v-col md="12">
                  <v-card>
                    <v-list flat>
                      <v-header>
                        <v-row>
                          <v-col md="12">
                            <PainelLancamentoNotas :trimestre="'IIIº Trimestre'" :tipoNota="3"
                              :isPautaBloqueada="isPautaBloqueada" :pautaLancada="pautaLancada"
                              :isRuleRolePed="isRuleRolePed" :snackbar.sync="snackbar" :text="text"
                              :estiloPauta="estiloPauta" :hasMessage="$store.state.hasMessage"
                              :classMessage="$store.state.classMessage" :textMessage="$store.state.textMessage"
                              @desbloquearPauta="desbloquearPauta" @publicarPauta="publicarPauta"
                              @fecharSnackbar="snackbar = false" />

                            <v-card-text>
                              <v-row>
                                <v-col md="4">
                                  <v-combobox :items="classes" v-model="classeSelected" item-text="descricao"
                                    label="Selecionar a classe" return-object @change="filtrarTurmas()"
                                    placeholder="Selecione a classe">
                                  </v-combobox>
                                </v-col>
                                <v-col md="4">
                                  <v-combobox :items="turmasFilter" v-model="turmaSelected" item-text="descricao"
                                    label="Selecionar a Turma" @change="findDisciplinaInProfDisc()"
                                    placeholder="Selecione a turma">
                                  </v-combobox>
                                </v-col>
                                <v-col md="4">
                                  <v-combobox :items="disciplinas" v-model="disciplinaSelected" @change="pautaByTurma()"
                                    item-text="descricao" label="Selecionar a Disciplina"
                                    placeholder="Selecione a disciplina" return-object>
                                  </v-combobox>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-col>
                        </v-row>
                      </v-header>

                      <!-- ********************************** CONFIGURAÇÃO PARA O NOVO ANOLECTIVO ****************************************** -->
                      <!--
            *
            *Descrição: Para o novo anolectivo 2023/24, o número de provas passa de duas ( p1,p2 ) para três provas trimestres (p1,p2,p3)
            *
            -->
                      <v-list-item-group v-model="item" color="primary" style="width: 100%"
                        v-if="anolectivo === '2023' && !isKalawenda">
                        <!--  1 e 2 trimestre  header -->
                        <v-row style="
                            background-color: #ccc;
                            margin-left: 0px;
                            width: 100%;
                          " v-if="listEstudantfromPauta.length">
                          <v-col cols="12" sm="12" md="1"></v-col>
                          <v-col cols="12" sm="12" md="1">N.</v-col>
                          <v-col cols="12" sm="12" md="2">Nome</v-col>

                          <v-col cols="12" sm="12" md="1">Mac</v-col>

                          <v-col cols="12" sm="12" md="1">PP</v-col>

                          <v-col cols="12" sm="12" md="1">PG</v-col>

                          <v-col cols="12" sm="12" md="1">MD</v-col>

                          <v-col cols="12" sm="12" md="1">Action</v-col>
                          <v-col cols="12" sm="12" md="1">Autor</v-col>
                        </v-row>

                        <hr v-if="listEstudantfromPauta.length" />
                        <br />

                        <v-list-item v-for="(item, i) in listEstudantfromPauta" :key="i">
                          <v-list-item-icon>
                            <v-icon v-text="item.icon"></v-icon>
                          </v-list-item-icon>
                          <!-- body 1  trimestre -->

                          <v-row class="bodyLancamentoNotas">
                            <v-col cols="12" sm="12" md="1">
                              <img class="photomouse" :src="getPhoto(item)" alt="avatar" width="30px;" />
                            </v-col>

                            <v-col cols="12" sm="12" md="1">{{ i + 1 }}.</v-col>

                            <v-col cols="12" sm="12" md="2">
                              <v-list-item-title v-text="item.nome"></v-list-item-title>
                            </v-col>

                            <v-col cols="12" sm="12" md="1">
                              <p v-if="editedpk !== item.pkpauta" class="text-lowercase">
                                {{ item.p3_notaMac }}
                              </p>
                              <v-text-field :rules="notaRules" v-if="editedpk === item.pkpauta"
                                v-model="editedItem.p3_notaMac" single-line></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="1">
                              <p v-if="editedpk !== item.pkpauta" class="text-lowercase">
                                {{ item.p3_nota }}
                              </p>
                              <v-text-field :rules="notaRules" v-if="editedpk === item.pkpauta"
                                v-model="editedItem.p3_nota" single-line></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="1">
                              <p v-if="editedpk !== item.pkpauta" class="text-lowercase">
                                {{ item.pg }}
                              </p>
                              <v-text-field :rules="notaRules" v-if="editedpk === item.pkpauta" v-model="editedItem.pg"
                                single-line></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="1">
                              <p class="text-lowercase">{{ item.p3_MD }}</p>
                            </v-col>
                            <v-col cols="12" sm="12" md="1" v-if="pautaLancada">
                              <!--=========
                          *
                          *Vai mostrar esse botão( Editar a nota ou lançar ) caso as notas do estudante não forem transportadas, se o estudante não for desistente ou ter a matricula anulada e se o usuário não seja administrador
                        <-->
                              <v-btn color="red" fab x-small dark :disabled="btn_activacao1" v-if="pautaBloqueada"
                                class="mr-2" text>
                                <v-icon>block</v-icon>
                              </v-btn>
                              <v-btn color="secondary" fab x-small dark :disabled="btn_activacao1" v-if="
                                !pautaBloqueada &&
                                editedpk !== item.pkpauta &&
                                !item.notas_transportadas &&
                                parseInt(item.desistente) !== 6 &&
                                parseInt(item.desistente) !== 7
                              " class="mr-2" @click="bt_edit(item)">
                                <v-icon>edit</v-icon>
                              </v-btn>

                              <p v-if="parseInt(item.desistente) === 6">
                                Desistente
                              </p>
                              <p v-if="parseInt(item.desistente) === 7">
                                Matricula Cancelada
                              </p>
                              <v-btn color="primary" fab x-small dark v-if="editedpk === item.pkpauta"
                                @click="bt_save(editedItem)">
                                <v-icon>save_alt</v-icon>
                              </v-btn>
                            </v-col>
                            <v-col cols="12" sm="12" md="1">
                              <span style="font-size: 8px">{{ item.autor }}--{{ item.data_2 }}</span>
                            </v-col>
                          </v-row>
                        </v-list-item>
                      </v-list-item-group>
                      <!-- **************** FIM DA CONFIGURAÇÃO PARA O NOVO ANOLECTIVO ***************************** -->

                      <v-list-item-group v-model="item" color="primary" style="width: 100%" v-else>
                        <!--  1 e 2 trimestre  header -->
                        <v-row style="
                            background-color: #ccc;
                            margin-left: 0px;
                            width: 100%;
                          " v-if="listEstudantfromPauta.length">
                          <v-col cols="12" sm="12" md="1"></v-col>
                          <v-col cols="12" sm="12" md="1">N.</v-col>
                          <v-col cols="12" sm="12" md="2">Nome</v-col>

                          <v-col cols="12" sm="12" md="1">Mac</v-col>

                          <v-col cols="12" sm="12" md="1">PP</v-col>

                          <v-col cols="12" sm="12" md="1">PT</v-col>

                          
                          <v-col
                            cols="12"
                            sm="12"
                            md="1"
                            v-if="
                              disciplinaSelected.isPratica === '1' &&
                              isintegrado
                            "
                            >NP</v-col
                          >

                          <v-col cols="12" sm="12" md="1">MD</v-col>

                          <v-col cols="12" sm="12" md="1">Action</v-col>
                          <v-col cols="12" sm="12" md="1">Autor</v-col>
                        </v-row>

                        <hr v-if="listEstudantfromPauta.length" />
                        <br />

                        <v-list-item v-for="(item, i) in listEstudantfromPauta" :key="i">
                          <v-list-item-icon>
                            <v-icon v-text="item.icon"></v-icon>
                          </v-list-item-icon>
                          <!-- body 1  trimestre -->

                          <v-row class="bodyLancamentoNotas">
                            <v-col cols="12" sm="12" md="1">
                              <img class="photomouse" :src="getPhoto(item)" alt="avatar" width="30px;" />
                            </v-col>

                            <v-col cols="12" sm="12" md="1">{{ i + 1 }}.</v-col>

                            <v-col cols="12" sm="12" md="2">
                              <v-list-item-title v-text="item.nome"></v-list-item-title>
                            </v-col>

                            <v-col cols="12" sm="12" md="1">
                              <p v-if="editedpk !== item.pkpauta" class="text-lowercase">
                                {{ item.p3_notaMac }}
                              </p>
                              <v-text-field :rules="notaRules" v-if="editedpk === item.pkpauta"
                                v-model="editedItem.p3_notaMac" single-line></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="1">
                              <p v-if="editedpk !== item.pkpauta" class="text-lowercase">
                                {{ item.p3_nota }}
                              </p>
                              <v-text-field :rules="notaRules" v-if="editedpk === item.pkpauta"
                                v-model="editedItem.p3_nota" single-line></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="1">
                              <p v-if="editedpk !== item.pkpauta" class="text-lowercase">
                                {{ item.p3_nota2 }}
                              </p>
                              <v-text-field :rules="notaRules" v-if="editedpk === item.pkpauta"
                                v-model="editedItem.p3_nota2" single-line></v-text-field>
                            </v-col>

                             <v-col
                              cols="12"
                              sm="12"
                              md="1"
                              v-if="
                                disciplinaSelected.isPratica === '1' &&
                                isintegrado
                              "
                            >
                              <p
                                v-if="editedpk !== item.pkpauta"
                                class="text-lowercase"
                              >
                                {{ item.p3_notaPratica }}
                              </p>
                              <v-text-field
                                :rules="notaRules"
                                v-if="editedpk === item.pkpauta"
                                v-model="editedItem.p3_notaPratica"
                                single-line
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="1">
                              <p class="text-lowercase">{{ item.p3_MD }}</p>
                            </v-col>
                            <v-col cols="12" sm="12" md="1" v-if="!pautaLancada">
                              <!--=========
                          *
                          *Vai mostrar esse botão( Editar a nota ou lançar ) caso as notas do estudante não forem transportadas, se o estudante não for desistente ou ter a matricula anulada e se o usuário não seja administrador
                        <-->
                              <v-btn color="red" fab x-small dark :disabled="btn_activacao1" v-if="pautaBloqueada"
                                class="mr-2" text>
                                <v-icon>block</v-icon>
                              </v-btn>
                              <v-btn color="secondary" fab x-small dark :disabled="btn_activacao1" v-if="
                                !pautaBloqueada &&
                                editedpk !== item.pkpauta &&
                                !item.notas_transportadas &&
                                parseInt(item.desistente) !== 6 &&
                                parseInt(item.desistente) !== 7
                              " class="mr-2" @click="bt_edit(item)">
                                <v-icon>edit</v-icon>
                              </v-btn>

                              <p v-if="parseInt(item.desistente) === 6">
                                Desistente
                              </p>
                              <p v-if="parseInt(item.desistente) === 7">
                                Matricula Cancelada
                              </p>
                              <v-btn color="primary" fab x-small dark :disabled="!formValid"
                                v-if="editedpk === item.pkpauta" @click="bt_save(editedItem)">
                                <v-icon>save_alt</v-icon>
                              </v-btn>
                            </v-col>
                            <v-col cols="12" sm="12" md="1">
                              <span style="font-size: 8px">{{ item.autor }}--{{ item.data_2 }}</span>
                            </v-col>
                          </v-row>
                        </v-list-item>
                      </v-list-item-group>
                      <!-- ***************************************************************************************** -->
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import photostudent from "../../../utilitarios/photo.services";
import Swal from "sweetalert2";
const ls = require("local-storage");
import PainelLancamentoNotas from "./componentes/PainelLancamentoNotas.vue";

export default {
  components: {
    PainelLancamentoNotas,
  },
  data: () => ({
    formValid: true,
    estiloPauta: "position:fixed;background-color:green;color:white;",
    on: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      // (value) => !!value || "campo obrigatório.",
      (v) => (v >= 0 && v <= 20) || "nota invalida",
      (v) => !isNaN(v) || "not number ",
      (value) => {
        const pattern = /^[+-]?\d+(\.\d+)?$/;
        return pattern.test(value) || "Invalido.";
      },
      (v) => (v !== null && v.length <= 4) || "valor inválido",
    ],
    text: "",
    editedpk: 0,
    profediscinas: [],
    diasDesbloqueio: [
      { id: 1, descricao: "1 dia" },
      { id: 2, descricao: "2 dias" },
      { id: 3, descricao: "3 dias" },
      { id: 4, descricao: "4 dias" },
      { id: 5, descricao: "5 dias" },
    ],
    classes: [
      { id: 1, descricao: "10ª classe" },
      { id: 2, descricao: "11ª classe" },
      { id: 3, descricao: "12ª classe" },
    ],
    pautaLancada: true,
    isPautaBloqueada: false,
    pautaBloqueada: false,
    publicar_status: false,
    tipoDeNota: 3,

    objBloqueioPauta: null,
    turmaSelected: null,
    overlay: false,
    role_usuario: "",
    disciplinas: [],
    _classe: "",
    Professor: "",
    dialog: false,
    text: '',
    snackbar: false,
    dialogoDisabilita: false,
    progresso_2: false,
    progresso_3: false,
    lancamentoSelected: 1,
    progresso: true,
    disciplinaSelected: null,
    idanoacademico: 0,
    offset: true,
    descricao_Prof: "",
    tumaSelect: "",
    iddisciplina: 0,
    btn_description: "",
    idturma: 0,
    closeOnClick: true,
    item: 1,
    listaPautasBloquadas: [],
    btn_activacao1: false,
    btn_activacao2: false,
    btn_activacao3: false,
    listaDeClassesPorLancarNotas: [],
    listEstudantfromPauta: [],
    roles: "prof",
    classeSelected: null,
    items: [
      { id: 1, descricao: "Nota por nota" },
      { id: 2, descricao: "Todas as notas" },
    ],
    editedIndex: -1,
    editedItem: {
      dayValidity: null,
      pkpauta: 0,
      p1_notaMac: 0,
      p1_nota: 0,
      p1_nota2: 0,
      p1_nota3: 0,
      p1_nota3: 0,
      p1_MD: 0,
      p2_notaMac: 0,
      p2_nota: 0,
      p2_nota2: 0,
      p2_nota3: 0,
      p2_MD: 0,
      p3_notaPratica: 0,
      p3_notaMac: 0,
      p3_nota: 0,
      p3_nota2: 0,
      p3_MD: 0,
      pg: 0,
      ca: 0,
      mfd: 0,
    },
  }),
  computed: {
    idclasse() {
      return this.$store.state.idclasse;
    },

    isKalawenda() {
      return ls.get('ims') === 'IMS-Kalawenda'
    },

    anolectivo() {
      return ls.get("anolectivo");
    },

    role() {
      return ls.get("role");
    },
    isintegrado() {
      return ls.get("isintegrado");
    },

    textoPautaBloqueada() {
      return !this.isPautaBloqueada ? "Pauta Bloqueada" : "";
    },

    isRuleRolePed() {
      if (this.role === "ROLE_PED") {
        return true;
      } else {
        return false;
      }
    },

  },

  watch: {
    disciplinaSelected: {
      handler() {
        this.isPautaBloqueada = !this.pautaLancada;
      },
      immediate: false
    },

    listaDeClassesPorLancarNotas() {
      this.$store.state.isloading = false;
    },
  },
  created() {
    if (ls.get("role") === "ROLE_COOR") {
      this.roles = "coor";
    }
    // this.CarregActividades()
    this.turmaFindWithEstudanteCount("all");
    this.initprofdisc();
    this.role_usuario = ls.get("role");
  },

  methods: {
    async publicarPauta() {
      Swal.fire({
        title: "Terminou de lançar as notas desta disciplina na turma?",
        text: `Após confirmar, não será mais possível alterar ou adicionar notas para esta turma.
    O sistema irá bloquear o acesso ao lançamento de notas para esta disciplina na turma.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, Finalizar e Bloquear Lançamento!",
        cancelButtonText: "Fechar",
        reverseButtons: true,
      }).then(async (result) => {
        if (!result.isConfirmed) return;

        const pkTurma = this.turmaSelected.pkTurma;
        const idDisciplina = this.listEstudantfromPauta[0].iddisciplina;
        const anoLectivo = ls.get("anolectivo");
        const idInstituicao = ls.get("i_id");

        const idPessoa = ls.get("idPessoa");
        const autorLancamento = this.role === 'ROLE_PED'
          ? 'DIRETOR_PEDAGOGICO'
          : 'PROFESSOR';

        // ✅ Verifica status do lançamento da pauta
        try {
          const status = await axios.post('/verificarStatusLancamentoPauta', {
            pkTurma,
            idDisciplina,
            anoLectivo,
            idInstituicao,
            tipoDeNota: this.tipoDeNota
          }).then(res => res.data);

          // 🔹 Caso 1: Nenhum dado existe ainda — publicar nova pauta
          if (!status.existe && !status.pautaLancada) {
            const publicar = await this.publicarLancamentoPauta(pkTurma, idDisciplina, anoLectivo, idInstituicao, this.tipoDeNota, autorLancamento, idPessoa);
            if (publicar) {
              Swal.fire("Informação", "Lançamento de notas concluído com sucesso. As notas foram publicadas e a pauta está agora bloqueada para novas edições.", "success");
              this.isPautaBloqueada = true;
              this.pautaLancada = true;
            } else {
              Swal.fire("Erro", "Não foi possível publicar a pauta.", "error");
            }
          }
          // 🔹 Caso 2: Já existe dado, mas ainda não está publicada (isNotaLancada = 0)
          else if (status.existe && !status.pautaLancada) {
            const bloquear = await this.bloquearLancamentoPauta(pkTurma, idDisciplina, anoLectivo, idInstituicao, this.tipoDeNota,);
            if (bloquear) {
              Swal.fire("Informação", "Pauta bloqueada com sucesso.", "success");
              this.isPautaBloqueada = true;
              this.pautaLancada = true;
            } else {
              Swal.fire("Erro", "Não foi possível bloquear a pauta novamente.", "error");
            }
          }
          // 🔹 Caso 3: Já existe e já foi publicada
          else if (status.existe && status.pautaLancada) {
            Swal.fire("Informação", "Esta pauta já foi publicada anteriormente. Nenhuma ação será realizada.", "info");
            this.isPautaBloqueada = true;
            this.pautaLancada = true;
          }

        } catch (error) {
          Swal.fire("Erro", "Erro ao verificar status da pauta. Tente novamente.", "error");
        }
      });
    },

    async verificarSePautaLancada(pkTurma, idDisciplina, anoLectivo, idInstituicao, tipoDeNota) {
      try {
        const response = await axios.post(
          `/verificarSePautaLancada/`,
          {
            pkTurma: pkTurma,
            idDisciplina: idDisciplina,
            anoLectivo: anoLectivo,
            idInstituicao: idInstituicao,
            tipoDeNota: tipoDeNota,
          }
        );
        this.isPautaBloqueada = response.data.pautaLancada;
        return response.data.pautaLancada;
      } catch (error) {
        return false;
      }
    },

    async verificarStatusLancamentoPauta(pkTurma, idDisciplina, anoLectivo, idInstituicao, tipoDeNota) {
      try {
        const response = await axios.post(
          `/verificarStatusLancamentoPauta/`,
          {
            pkTurma: pkTurma,
            idDisciplina: idDisciplina,
            anoLectivo: anoLectivo,
            idInstituicao: idInstituicao,
            tipoDeNota: tipoDeNota,
          }
        );
        return response.data;
      } catch (error) {
        return false;
      }
    },

    async publicarLancamentoPauta(pkTurma, idDisciplina, anoLectivo, idInstituicao, tipoDeNota, autorLancamento, idPessoa) {
      try {

        const response = await axios.post(
          `/publicarLancamentoPauta/`,
          {
            pkTurma: pkTurma,
            idDisciplina: idDisciplina,
            anoLectivo: anoLectivo,
            idInstituicao: idInstituicao,
            tipoDeNota: tipoDeNota,
            autorLancamento: autorLancamento,
            idPessoa: idPessoa,
          }
        ).then((res) => res.data).catch((err) => console.log(err));
        this.pautaLancada = false;
        this.publicar_status = true;
        return response;
      } catch (error) {
        Swal.fire("Erro", "Erro ao publicar a pauta. Tente novamente.", "error");
      }
    },

    async bloquearLancamentoPauta(pkTurma, idDisciplina, anoLectivo, idInstituicao, tipoDeNota) {
      try {
        // console.log(`pkTurma: ${pkTurma}, idDisciplina: ${idDisciplina}, anoLectivo: ${anoLectivo}, idInstituicao: ${idInstituicao}, tipoDeNota: ${tipoDeNota}`);

        const response = await axios.post('/bloquearLancamentoPauta', {
          pkTurma: pkTurma,
          idDisciplina: idDisciplina,
          anoLectivo: anoLectivo,
          idInstituicao: idInstituicao,
          tipoDeNota: tipoDeNota,
        });


        // Sucesso ao reabrir a pauta
        this.isPautaBloqueada = true;
        this.pautaLancada = true;
        Swal.fire("Informação", "Pauta reaberta com sucesso.", "success");
        // this.$toast.success(response.data.message || 'Pauta reaberta com sucesso.');
        return true;
      } catch (error) {
        Swal.fire("Informação", "Erro ao reabrir a pauta.", "error");
        return false;
      }
    },


    classe(idanoacademico) {
      if (idanoacademico === 1) {
        this._classe = "10ª Classe";
      }
      if (idanoacademico === 2) {
        this._classe = "11ª Classe";
      }
      if (idanoacademico === 3) {
        this._classe = "12ª Classe";
      }
      if (idanoacademico === 4) {
        this._classe = "13ª Classe";
      }

      this.idanoacademico = idanoacademico;
    },
    loadprogressbar() {
      this.$store.state.isloading = true;
    },

    bt_edit(item) {
      this.editedIndex = this.listEstudantfromPauta.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedpk = item.pkpauta;
      this.editedItem.trimestre = this.$store.state.idperfilpauta;
      this.editedItem.pkpauta = item.pkpauta;

      setTimeout(() => { }, 1000);
    },
    MostrarDialogo() {
      this.dialog = true;
    },

    MostrarDialogoDisabilitar() {
      this.dialogoDisabilita = true;
    },


    bt_save(editedItem) {
  // Função auxiliar para calcular a média de notas com qualquer quantidade de argumentos
  
  const calcularMediaNotas = (...notas) => {
    // Converte todas as notas para número
    const numeros = notas.map(n => Number(n));
    // Soma todos os valores
    const soma = numeros.reduce((a, b) => a + b, 0);
    // Calcula a média e formata com 1 casa decimal
    const media = soma / numeros.length;
    return media.toFixed(1);
  };

  // Calcula a média do primeiro período (p1_MD) com base nas três notas
  editedItem.p1_MD = calcularMediaNotas(
    editedItem.p1_notaMac,
    editedItem.p1_nota,
    editedItem.p1_nota2
  );

  // Calcula a média do segundo período (p2_MD) com base nas três notas
  editedItem.p2_MD = calcularMediaNotas(
    editedItem.p2_notaMac,
    editedItem.p2_nota,
    editedItem.p2_nota2
  );

  // Verifica se  a classe é a 12ª
  if (this.classeSelected.id === 3) {
    // Se for   12 classe, calcula média a do 3º trimestre (p3_MD) com apenas duas notas
    editedItem.p3_MD = calcularMediaNotas(
      editedItem.p3_notaMac,
      editedItem.p3_nota
    );
  } else {


    // Caso contrário, calcula média do 3º período com três notas
    editedItem.p3_MD = calcularMediaNotas(
      editedItem.p3_notaMac,
      editedItem.p3_nota,
      editedItem.p3_nota2
    );

    let md3 = editedItem.p3_MD 

    if(this.disciplinaSelected.isPratica === "1" && this.isintegrado){
         let p3_md = Math.round(
          md3 * 0.4 + Number(this.editedItem.p3_notaPratica) * 0.6
        );

         editedItem.p3_MD = p3_md;
    }
  }

  // Verifica se o formulário é válido
  if (this.formValid) {
    // Salva o item editado
    this.save(editedItem);

    // Reseta o identificador de item em edição
    this.editedpk = 0;
  }
},

    backTodisciplinList() {
      this.listEstudantfromPauta = [];
    },
    backToTurmaList() {
      this.disciplinas = [];
    },

    filtrarTurmas() {
      this.overlay = true;
      this.turmasFilter = [];
      this.disciplinas = [];
      this.listEstudantfromPauta = [];
      this.disciplinaSelected = null;
      this.turmaSelected = null;
      this.turmasFilter = this.listaDeClassesPorLancarNotas.filter(
        (t) => t.idAno_Academico === this.classeSelected.id
      );
      this.overlay = false;
    },

    async turmaFindWithEstudanteCount(idclasse) {
      this.progresso = true;
      try {
        this.progresso = true;
        this.listaDeClassesPorLancarNotas = await axios
          .get("/turmaFindWithEstudanteCount/" + "all") // idclasse JyUn JQ==
          .then((res) => res.data);
        this.progresso = false;
      } catch (error) {
        // this.isLoading = false
        this.progresso = false;
        // this.text = error
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
      this.listEstudantfromPauta = [];
    },

    async save(editedItem) {

      // if (this.$refs.form.validate()) {


      if (this.role === "ROLE_ADM") {
        this.estiloPauta = "position:fixed;background-color:red;color:white;";
        this.$store.dispatch("textMessage", {
          msg: "Não é permitido ao administrador Lançar Notas ou altera-las.",
          classMessage: "msgError",
          timeout: 8000,
        });
      } else {
        var params = {
          p1_notaMac: editedItem.p1_notaMac,
          p1_nota: editedItem.p1_nota,
          p1_nota2: editedItem.p1_nota2,
          p1_nota3: editedItem.p1_nota3,
          p1_MD: editedItem.p1_MD,
          p2_notaMac: editedItem.p2_notaMac,
          p2_nota: editedItem.p2_nota,
          p2_nota2: editedItem.p2_nota2,
          p2_nota3: editedItem.p2_nota3,
          p2_MD: editedItem.p2_MD,
          p3_notaMac:
            editedItem.p3_notaMac !== null && editedItem.p3_notaMac.length <= 2
              ? editedItem.p3_notaMac + ".0"
              : editedItem.p3_notaMac,
          p3_nota:
            editedItem.p3_nota !== null && editedItem.p3_nota.length <= 2
              ? editedItem.p3_nota + ".0"
              : editedItem.p3_nota,
          p3_nota2:
            editedItem.p3_nota2 !== null && editedItem.p3_nota2.length <= 2
              ? editedItem.p3_nota2 + ".0"
              : editedItem.p3_nota2,
          p3_MD:
            editedItem.p3_MD !== null && editedItem.p3_MD.length <= 2
              ? editedItem.p3_MD + ".0"
              : editedItem.p3_MD,
          pg:
            editedItem.pg !== null && editedItem.pg.length <= 2
              ? editedItem.pg + ".0"
              : editedItem.pg,
          ca: editedItem.ca,
          p3_notaPratica: editedItem.p3_notaPratica !== null &&
            editedItem.p3_notaPratica.length > 0 &&
            editedItem.p3_notaPratica.length <= 2
              ? editedItem.p3_notaPratica + ".0"
              : editedItem.p3_notaPratica,
          mfd: editedItem.mfd,
          autor: ls.get("nomeUsuario"),
          pkpauta: editedItem.pkpauta,
          trimestre: 3,
        };

        try {
          let msg = await axios
            .post("/lancarNota", params)
            .then((res) => res.data);
          // this.text = msg[1].insertId
          this.text = msg;

          try {
            if (msg.affectedRows >= 1) {
              this.text = msg.affectedRows + " gravado(s) com sucesso";
              this.$store.dispatch("textMessage", {
                msg: this.text,
                classMessage: "msgSucess",
                timeout: 2000,
              });
              Object.assign(
                this.listEstudantfromPauta[this.editedIndex],
                params
              );
            }
          } catch (error) { }
          try {
            this.text = msg.message.sqlMessage;
            this.$store.dispatch("textMessage", {
              msg: this.text,
              classMessage: "msgError",
              timeout: 8000,
            });
          } catch (error) { }
          try {
            this.text = msg.message.sqlMessage;
            this.$store.dispatch("textMessage", {
              msg: this.text,
              classMessage: "msgError",
              timeout: 8000,
            });
          } catch (error) { }

          if (this.editedIndex > -1) {
            //  Object.assign(this.estudantes[this.editedIndex], this.editedItem)
          } else {
            this.estudantes.push(this.editedItem);
          }
          //  this.close();
        } catch (error) {
          this.isLoading = false;

          this.text = error.message;
          this.$store.dispatch("textMessage", {
            msg: this.text + " - " + error,
            classMessage: "msgError",
            timeout: 8000,
          });
        } finally {
        }
      }
      // }else{
      //      this.text = 'Preencha todos os campos para salvar as notas.'
      //      this.snackbar = true
      // }
    },

    async criarExcecaoDeDesbloqueiodePauta() {
      let params = {
        id: null,
        disciplina: this.$store.state.objDisciplina,
        turma: this.$store.state.objturma,
        autor: ls.get("nomeUsuario"),
        dayValidity: this.editedItem.dayValidity,
        trimestre: 1,
      };

      try {
        let result = await axios
          .post("/exceptionMiniPautaInsertOrUpdate", params)
          .then((res) => res.data);
        if (result.affectedRows >= 1) {
          this.dialogoDisabilita = false;
          this.pautaBloqueada = false;
          this.$store.dispatch("textMessage", {
            msg: "Pauta desbloqueada com sucesso",
            classMessage: "msgError",
            timeout: 8000,
          });
        }
      } catch (error) {
        this.estiloPauta = "position:fixed;background-color:red;color:white;";
        this.$store.dispatch("textMessage", {
          msg: "Ocorreu um erro ao tentar efectuar a operação",
          classMessage: "msgError",
          timeout: 8000,
        });
      }
    },

    async pautaByTurma() {

      try {

        if (!this.turmaSelected || !this.disciplinaSelected) {
          return;
        }

        const pkTurma = this.turmaSelected.pkTurma;
        const anoLectivo = this.anolectivo;
        const idDisciplina = this.disciplinaSelected.iddisciplina;
        const idInstituicao = ls.get("i_id");

        this.pautaLancada = await this.verificarSePautaLancada(
          pkTurma,
          idDisciplina,
          anoLectivo,
          idInstituicao,
          this.tipoDeNota
        );


        // carrega turma apartir de bauta  Turma
        let obj = this.disciplinaSelected;
        this.$store.state.disciplina = obj.iddisciplina;
        this.$store.state.objDisciplina = obj;
        const payload =
          '{"iddisciplina":"' +
          obj.iddisciplina +
          '" , "pkturma":"' +
          obj.pkturma +
          '", "i_id":"' +
          ls.get("i_id") +
          '"  }';


        this.overlay = true;
        this.listEstudantfromPauta = await axios

          .get("/listEstudantfromPauta/" + payload)
          .then((res) => res.data);

        this.overlay = false;
        if (!this.listEstudantfromPauta.length) {
          Swal.fire(
            "Informação",
            "Não foram encontrados estudantes na turma",
            "warning"
          );
        }
        this.MostraProfessor();
        this.CarregaPautas()
      } catch (error) {
        // this.isLoading = false
        this.overlay = false;
        // this.text = error
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    async initprofdisc(search) {
      try {
        if (!search) {
          var payload = '{"find":"all"}';
        } else {
          payload = '{"find":"' + search + '"}';
        }
        this.profediscinas = await axios
          .get("/professordiscFindAll/" + payload)
          .then((res) => res.data);
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    async PublicarPauta() {
      const valores = {
        disciplina: this.$store.state.objDisciplina,
        curso: this.$store.state.objturma,
        trimestre: 1,
        autor: ls.get("nomeUsuario"),
        classe: this.editedItem.classe,
        bloqueada: 1,

        // turma: this.$store.state.objturma,
        // disciplina: this.$store.state.disciplina,
        // trimestre: this.$store.state.lancarNotaDe,
        // bloquear: 1,
        // publicar: 1,
        // idControlopauta: 0,
        // idCurso: this.$store.state.objturma
      };

      // Consumindo a API
      try {
        // eslint-disable-next-line no-unused-vars
        let valor = await axios

          .post("/bloquearPauta", valores)
          .then((res) => res.data);
        // eslint-disable-next-line no-unused-vars
        let text = "Pauta publicada com sucesso";
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgSucess",
          timeout: 8000,
        });
        this.dialog = false;

        this.$store.state.bloqueado.push(valores);
        // this.$store.state.bloqueado = []
        // CarregaPauta
        this.verificaPautas();
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    async CarregActividades() {
      try {
        this.$store.state.actividades = await axios
          .get("/listAberturaFechoInstituicao")
          .then((res) => res.data);
      } catch (error) { }
    },

    MostraProfessor() {
      let valor = this.profediscinas.filter(
        (d) => d.iddisciplina === this.$store.state.disciplina
      );
      if (valor.length) {
        this.Professor = valor[0].nome;
        this.descricao_Prof = "disciplina atrbuida ao Professor";
      } else {
        this.Professor = "Sem Professor Associado";
        this.descricao_Prof = "";
      }
    },

    irParaValiacao(item) {
      this.$store.state.objPauta = item;
      this.$store.state.rotas = "lancar-trimestre-um";
      this.$router.push("avalicacao-comportamento");
    },

    async CarregaPautas() {
      this.overlay = true;
      try {
        let params = {
          disciplina: this.$store.state.disciplina,
          turma: this.$store.state.objturma,
          trimestre: 3,
        };

        let results = await axios.post("/ListarPautaBloqueada", params).then((res) => res.data);
        if (results.length) {
          this.objBloqueioPauta = results[0];
          this.pautaBloqueada = true;
        } else {
          this.pautaBloqueada = false;
        }

      } catch (error) {
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.overlay = false;
      }
    },

    async VerificaExcecaoBloqueioPauta() {
      this.overlay = true;
      try {
        let params = {
          disciplina: this.$store.state.objDisciplina,
          turma: this.$store.state.objturma,
          trimestre: 3,
        };

        return await axios
          .post("/ObterExceptionMinipauta", params)
          .then((res) => res.data);
      } catch (error) {
        this.overlay = false;
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.overlay = false;
      }
    },

    TrimestreToInteger(value) {
      switch (value) {
        case "1º Trimestre":
          return 1;
        case "2º Trimestre":
          return 2;
        case "3º Trimestre":
          return 4;

        default:
          break;
      }
    },

    HabilitaBotoes(valor) {
      if (
        this.listaPautasBloquadas.filter((t) => t.trimestre === "1º Trimestre")
      ) {
        this.btn_activacao1 = valor;
      }
      if (
        this.listaPautasBloquadas.filter((t) => t.trimestre === "2º Trimestre")
      ) {
        this.btn_activacao2 = valor;
      }
      if (
        this.listaPautasBloquadas.filter((t) => t.trimestre === "3º Trimestre")
      ) {
        this.btn_activacao3 = valor;
      }
    },

    MudarFormaLancamento() { },

    verificaPautas() {
      if (this.listaPautasBloquadas.length) {
        this.HabilitaBotoes(true);

        this.$store.state.Controlopauta =
          this.listaPautasBloquadas[0].idControlopauta;
        if (ls.get("role") === "ROLE_PROF") {
          this.publicar_status = true;
          this.btn_description = "Mini Pauta Bloqueada";
        } else {
          this.publicar_status = true;
          this.HabilitaBotoes(false);
          this.btn_description = "Mini Pauta Bloqueada";
        }
      } else {
        this.publicar_status = false;
        this.btn_description = "Bloquear";
        this.HabilitaBotoes(false);
      }
    },

    async findDisciplinaInProfDisc() {
      this.overlay = true;
      this.disciplinas = [];
      this.listEstudantfromPauta = [];
      this.disciplinaSelected = null;
      let obj = this.turmaSelected;
      this.disciplinas = [];
      this.$store.state.turma = obj.descricao;
      this.$store.state.objturma = obj;
      try {
        this.progresso_2 = true;
        this.disciplinas = await axios

          .get("/findDisciplinaInProfDisc/" + obj.pkTurma)
          .then((res) => res.data);
        this.progresso_2 = false;
        this.overlay = false;
      } catch (error) {
        // this.isLoading = false
        this.progresso_2 = false;
        this.overlay = false;
        // this.text = error
        Swal.fire(
          "Informação",
          "Ocorreu um erro ao tentar efectuar a operação",
          "error"
        );
      }
    },
    getPhoto(item) {
      try {
        return photostudent.getPhotoStudent(item.matricula);
      } catch (error) {
        Swal.fire("Informação", "Ocorreu um erro ao carregar a foto", "error");
      }
    },

    irAvaliarComportamento() {
      this.$store.state.rotas = "lancar-trimestre-um";
      this.$store.state.Pautas = this.listEstudantfromPauta;
      this.$router.push("comportamento");
    },
  },
};
</script>
<style scoped>
.bodyLancamentoNotas {
  width: 100%;
  margin-left: -60px;
}
</style>
